import ascending from "./ascending.js";
import permute from "./permute.js";
export default function sort(values) {
  var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ascending;
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  values = Array.from(values);

  if (f.length === 1) {
    f = values.map(f);
    return permute(values, values.map(function (d, i) {
      return i;
    }).sort(function (i, j) {
      return ascending(f[i], f[j]);
    }));
  }

  return values.sort(f);
}